<template>
  <div class="thirdDetail">
    <common-detail
      thirdParty
      hasPhone
      :title="detail.serviceName"
      :imgList="detail.servicePictures"
      :phoneNumber="detail.phone"
    ></common-detail>
  </div>
</template>

<script>
import { getServiceDetail } from "@/api/service.js";
export default {
  name: "thirdDetail",
  data() {
    return {
      detail: {}
    };
  },
  methods: {
    async getData() {
      const res = await getServiceDetail(this.$route.query.id);
      this.detail = res;
    }
  },
  mounted() {
    window.document.title = this.$route.query.serviceName;
    this.getData();
  }
};
</script>

<style scoped>

</style>
